function generateParamsFromObj(
  obj: Record<
    string,
    string | string[] | number[] | Record<string, string | string[] | number[]>
  >,
  globalPrefix: string = ""
) {
  const params = new URLSearchParams();

  function addParams(currentObj: any, prefix: string = "") {
    for (const key in currentObj) {
      const value = currentObj[key];
      const fullKey = prefix ? `${prefix}[${key}]` : key;

      if (
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value)
      ) {
        addParams(value, key);
      } else if (Array.isArray(value)) {
        if (typeof value[0] === "number" && prefix === "filters") {
          params.append(`${prefix}[${key}Min]`, value[0].toString());
          params.append(`${prefix}[${key}Max]`, value[1].toString());
        } else {
          value.forEach((el: string | number) =>
            params.append(fullKey, el.toString())
          );
        }
      } else if (value !== "" && typeof value !== "object") {
        !!value ? params.append(fullKey, value.toString()) : null;
      }
    }
  }

  addParams(obj, globalPrefix);
  return params;
}
export default generateParamsFromObj;
